const hostUrl = new URL((document.currentScript as HTMLScriptElement).src).origin;

const bugsnagReleaseStage = (process.env.REACT_APP_BUGSNAG_RELEASE_STAGE || process.env.REACT_APP_ENV) as string;

window.phoenixConfig = {
  appVersionPhoenix: process.env.REACT_APP_CURRENT_REV_SHA as string,
  echoBaseUrl: process.env.REACT_APP_API_URL as string,
  bugsnagApiKey: process.env.REACT_APP_BUGSNAG_API as string,
  bugsnagReleaseStage,
  echoUiUrl: `${hostUrl}/echoUi`,
  env: process.env.REACT_APP_ENV as Environments,
  memberSvcOnPremToken: process.env.REACT_APP_MEMBER_SERVICE_ON_PREM_TOKEN as string,
  memberSvcUrl: `${hostUrl}/member-service`,
  muiProLicense: process.env.REACT_APP_MUI_PRO_LICENSE as string,
  phoenixUrl: `${hostUrl}/phoenix`,
  pushJsKey: process.env.REACT_APP_PUSHER_KEY as string,
  pusherJsCluster: process.env.REACT_APP_PUSHER_CLUSTER as string,
};
window.PHOENIX_PIPELINE_URL = process.env.REACT_APP_PHOENIX_PIPELINE_URL as string;
window.PHOENIX_SHA = process.env.REACT_APP_CURRENT_REV_SHA as string;

import("./bootstrap").catch(e => {
  alert("Oops, something went wrong! Please reload the page.");
  throw e;
});

export {};
